import { Switch, Field, Label } from "@headlessui/react";
import clsx from "clsx";

export default function ToggleSwitch({
	enabled,
	setEnabled,
	label,
}: {
	enabled: boolean;
	setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	label: string;
}) {
	return (
		<Field className="eL-flex eL-items-center eL-space-x-2">
			<Label as="span" className="eL-text-sm hover:eL-cursor-pointer">
				{label.length > 0 ? (
					<span className="eL-font-medium eL-text-gray-900">{label}</span>
				) : (
					<span className="eL-text-[0.9rem] eL-text-gray-500">
						I understand this has no impact on my credit score and agree to the{" "}
						<a
							className="eL-text-[--eL-theme-color] eL-font-semibold"
							href="/privacy-policy"
							target="_blank"
						>
							terms & conditions
						</a>
						.
					</span>
				)}
			</Label>
			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={clsx(
					enabled ? "" : "eL-bg-gray-200",
					`eL-relative eL-inline-flex eL-h-6 eL-w-11 eL-flex-shrink-0 eL-cursor-pointer eL-rounded-full eL-border-2 eL-border-[--eL-theme-color] eL-transition-colors eL-duration-200 eL-ease-in-out focus:eL-outline-none focus:eL-ring-2 focus:eL-ring-offset-2`
				)}
				style={
					{
						backgroundColor: enabled ? "var(--eL-theme-color)" : "",
						"--tw-ring-color": "var(--eL-theme-color)",
					} as React.CSSProperties
				}
			>
				<span className="eL-sr-only">Use setting</span>
				<span
					className={clsx(
						enabled ? "eL-translate-x-5" : "eL-translate-x-0",
						"eL-pointer-events-none eL-relative eL-inline-block eL-h-5 eL-w-5 eL-transform eL-rounded-full eL-bg-white eL-shadow eL-ring-0 eL-transition eL-duration-200 eL-ease-in-out"
					)}
				>
					<span
						className={clsx(
							enabled
								? "eL-opacity-0 eL-duration-100 eL-ease-out"
								: "eL-opacity-100 eL-duration-200 eL-ease-in",
							"eL-absolute eL-inset-0 eL-flex eL-h-full eL-w-full eL-items-center eL-justify-center eL-transition-opacity"
						)}
						aria-hidden="true"
					>
						<svg
							className="eL-h-3 eL-w-3 eL-text-gray-400"
							fill="none"
							viewBox="0 0 12 12"
						>
							<path
								d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
								stroke="var(--eL-theme-color)"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</span>
					<span
						className={clsx(
							enabled
								? "eL-opacity-100 eL-duration-200 eL-ease-in"
								: "eL-opacity-0 eL-duration-100 eL-ease-out",
							"eL-absolute eL-inset-0 eL-flex eL-h-full eL-w-full eL-items-center eL-justify-center eL-transition-opacity"
						)}
						aria-hidden="true"
					>
						<svg
							className="eL-h-3 eL-w-3 eL-text-green-400"
							fill="var(--eL-theme-color)"
							viewBox="0 0 12 12"
						>
							<path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
						</svg>
					</span>
				</span>
			</Switch>
		</Field>
	);
}
